import { Card } from 'entities/card/model/types';
import { api } from 'shared/api';
import { ApiResponse } from 'shared/model/types';

const getPlasticApi = api.injectEndpoints({
  endpoints: (build) => ({
    order: build.mutation<
      ApiResponse<Card>,
      {
        accountId: string;
        staticPassword: string;
        address1: string;
        address2: string;
        postalCode: string;
        city: string;
        phoneCountry: number;
      }
    >({
      query: ({ accountId, ...body }) => ({
        url: `private/river/${accountId}/card/physical/application`,
        method: 'POST',
        body,
      }),
    }),
  }),
});
export const { useOrderMutation } = getPlasticApi;

export default getPlasticApi;
